import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment';

export default {
  name: 'LostModuleDashboard',
  components: {
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        fromDate : '',
        toDate:'',
        getServiceCenterDebitsData:{},
        HubZoneName :'',
        DebitFromType :'',
        SubStatus :'',
        getLineHaulDebitsData:{},
        getVehicleVendorDebitsData:{},
        getSuperAgentDebitsData:{},
        searchflag:false,
        localuserid:'',
        localusermailid:'',
        getLostShipmetsDetailsflag:false,
        getLostShipmetsDetailsData:[],
        pagecount: 1,
        pageno: 1,
        searchDashboardCount: false,
        searchShipmentSummary: false,
        getAttachmentListData: [],
        getAttachmentFlag: false,
        attachmentLoader: false,
        userDataKey : '',
      }
  },
  created: function() {
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

    //console.log('Mixin is working for :',result);
  },
  methods : {
     getLostShipmetsData(){
       if(this.toDate >= this.fromDate ){
         this.searchDashboardCount = true
         axios({
           method: "POST",
           url:  apiUrl.api_url + 'lostModuleDashboard/search',
           data: {
             "FromDate" : this.fromDate,
             "ToDate" : this.toDate,
             "username" : this.localusermailid
           },
           header: {
             "content-type" : "application/json",
             "versionnumber" : "v1",
             "token" : "xyz"
           }
         }).then((response) => {

              if(response.data.code===200){
                this.getServiceCenterDebitsData = response.data.data.ServiceCenter;
                this.getLineHaulDebitsData = response.data.data.LineHaul;
                this.getVehicleVendorDebitsData = response.data.data.Vendor;
                this.getSuperAgentDebitsData = response.data.data.SuperAgent;

                this.getServiceCenterDebitsData.Total ={};
                this.getLineHaulDebitsData.Total ={};
                this.getVehicleVendorDebitsData.Total ={};
                this.getSuperAgentDebitsData.Total ={};
                // console.log('this.getServiceCenterDebitsData', this.getServiceCenterDebitsData);
                this.getServiceCenterDebitsData.Total.PendingMarkLostTotal = parseInt(response.data.data.ServiceCenter.West.MarkLost)
                + parseInt(response.data.data.ServiceCenter.East.MarkLost) + parseInt(response.data.data.ServiceCenter.North.MarkLost)
                + parseInt(response.data.data.ServiceCenter.South1.MarkLost) + parseInt(response.data.data.ServiceCenter.South2.MarkLost)
                + parseInt(response.data.data.ServiceCenter.Central.MarkLost) + parseInt(response.data.data.ServiceCenter.NorthEast.MarkLost);

                this.getServiceCenterDebitsData.Total.PendingDebitsTotal = parseInt(response.data.data.ServiceCenter.West.Pending)
                + parseInt(response.data.data.ServiceCenter.East.Pending) + parseInt(response.data.data.ServiceCenter.North.Pending)
                + parseInt(response.data.data.ServiceCenter.South1.Pending) + parseInt(response.data.data.ServiceCenter.South2.Pending)
                + parseInt(response.data.data.ServiceCenter.Central.Pending) + parseInt(response.data.data.ServiceCenter.NorthEast.Pending);

                this.getServiceCenterDebitsData.Total.PendingRMApprovalTotal = parseInt(response.data.data.ServiceCenter.West.RMApprove)
                + parseInt(response.data.data.ServiceCenter.East.RMApprove) + parseInt(response.data.data.ServiceCenter.North.RMApprove)
                + parseInt(response.data.data.ServiceCenter.South1.RMApprove) + parseInt(response.data.data.ServiceCenter.South2.RMApprove)
                + parseInt(response.data.data.ServiceCenter.Central.RMApprove) + parseInt(response.data.data.ServiceCenter.NorthEast.RMApprove);

                this.getServiceCenterDebitsData.Total.PendingHRApprovalTotal = parseInt(response.data.data.ServiceCenter.West.HRApprove)
                + parseInt(response.data.data.ServiceCenter.East.HRApprove) + parseInt(response.data.data.ServiceCenter.North.HRApprove)
                + parseInt(response.data.data.ServiceCenter.South1.HRApprove) + parseInt(response.data.data.ServiceCenter.South2.HRApprove)
                + parseInt(response.data.data.ServiceCenter.Central.HRApprove) + parseInt(response.data.data.ServiceCenter.NorthEast.HRApprove);

                this.getServiceCenterDebitsData.Total.PendingFinanceApprovalTotal = parseInt(response.data.data.ServiceCenter.West.FinanceApprove)
                + parseInt(response.data.data.ServiceCenter.East.FinanceApprove) + parseInt(response.data.data.ServiceCenter.North.FinanceApprove)
                + parseInt(response.data.data.ServiceCenter.South1.FinanceApprove) + parseInt(response.data.data.ServiceCenter.South2.FinanceApprove)
                + parseInt(response.data.data.ServiceCenter.Central.FinanceApprove) + parseInt(response.data.data.ServiceCenter.NorthEast.FinanceApprove);


                this.getLineHaulDebitsData.Total.PendingMarkLostTotal = parseInt(response.data.data.LineHaul.West.MarkLost)
                + parseInt(response.data.data.LineHaul.East.MarkLost) + parseInt(response.data.data.LineHaul.North.MarkLost)
                + parseInt(response.data.data.LineHaul.South1.MarkLost) + parseInt(response.data.data.LineHaul.South2.MarkLost)
                + parseInt(response.data.data.LineHaul.Central.MarkLost) + parseInt(response.data.data.LineHaul.NorthEast.MarkLost);

                this.getLineHaulDebitsData.Total.PendingDebitsTotal = parseInt(response.data.data.LineHaul.West.Pending)
                + parseInt(response.data.data.LineHaul.East.Pending) + parseInt(response.data.data.LineHaul.North.Pending)
                + parseInt(response.data.data.LineHaul.South1.Pending) + parseInt(response.data.data.LineHaul.South2.Pending)
                + parseInt(response.data.data.LineHaul.Central.Pending) + parseInt(response.data.data.LineHaul.NorthEast.Pending);

                this.getLineHaulDebitsData.Total.PendingRMApprovalTotal = parseInt(response.data.data.LineHaul.West.RMApprove)
                + parseInt(response.data.data.LineHaul.East.RMApprove) + parseInt(response.data.data.LineHaul.North.RMApprove)
                + parseInt(response.data.data.LineHaul.South1.RMApprove) + parseInt(response.data.data.LineHaul.South2.RMApprove)
                + parseInt(response.data.data.LineHaul.Central.RMApprove) + parseInt(response.data.data.LineHaul.NorthEast.RMApprove);

                this.getLineHaulDebitsData.Total.PendingtransitApprovedTotal = parseInt(response.data.data.LineHaul.West.transitApproved)
                + parseInt(response.data.data.LineHaul.East.transitApproved) + parseInt(response.data.data.LineHaul.North.transitApproved)
                + parseInt(response.data.data.LineHaul.South1.transitApproved) + parseInt(response.data.data.LineHaul.South2.transitApproved)
                + parseInt(response.data.data.LineHaul.Central.transitApproved) + parseInt(response.data.data.LineHaul.NorthEast.transitApproved);

                this.getLineHaulDebitsData.Total.PendingFinanceApprovalTotal = parseInt(response.data.data.LineHaul.West.FinanceApprove)
                + parseInt(response.data.data.LineHaul.East.FinanceApprove) + parseInt(response.data.data.LineHaul.North.FinanceApprove)
                + parseInt(response.data.data.LineHaul.South1.FinanceApprove) + parseInt(response.data.data.LineHaul.South2.FinanceApprove)
                + parseInt(response.data.data.LineHaul.Central.FinanceApprove) + parseInt(response.data.data.LineHaul.NorthEast.FinanceApprove);

                this.getVehicleVendorDebitsData.Total.PendingMarkLostTotal = parseInt(response.data.data.Vendor.West.MarkLost)
                + parseInt(response.data.data.Vendor.East.MarkLost) + parseInt(response.data.data.Vendor.North.MarkLost)
                + parseInt(response.data.data.Vendor.South1.MarkLost) + parseInt(response.data.data.Vendor.South2.MarkLost)
                + parseInt(response.data.data.Vendor.Central.MarkLost) + parseInt(response.data.data.Vendor.NorthEast.MarkLost);

                this.getVehicleVendorDebitsData.Total.PendingDebitsTotal = parseInt(response.data.data.Vendor.West.Pending)
                + parseInt(response.data.data.Vendor.East.Pending) + parseInt(response.data.data.Vendor.North.Pending)
                + parseInt(response.data.data.Vendor.South1.Pending) + parseInt(response.data.data.Vendor.South2.Pending)
                + parseInt(response.data.data.Vendor.Central.Pending) + parseInt(response.data.data.Vendor.NorthEast.Pending);

                this.getVehicleVendorDebitsData.Total.PendingRMApprovalTotal = parseInt(response.data.data.Vendor.West.RMApprove)
                + parseInt(response.data.data.Vendor.East.RMApprove) + parseInt(response.data.data.Vendor.North.RMApprove)
                + parseInt(response.data.data.Vendor.South1.RMApprove) + parseInt(response.data.data.Vendor.South2.RMApprove)
                + parseInt(response.data.data.Vendor.Central.RMApprove) + parseInt(response.data.data.Vendor.NorthEast.RMApprove);

                this.getVehicleVendorDebitsData.Total.PendingFinanceApprovalTotal = parseInt(response.data.data.Vendor.West.FinanceApprove)
                + parseInt(response.data.data.Vendor.East.FinanceApprove) + parseInt(response.data.data.Vendor.North.FinanceApprove)
                + parseInt(response.data.data.Vendor.South1.FinanceApprove) + parseInt(response.data.data.Vendor.South2.FinanceApprove)
                + parseInt(response.data.data.Vendor.Central.FinanceApprove) + parseInt(response.data.data.Vendor.NorthEast.FinanceApprove);


                this.getSuperAgentDebitsData.Total.PendingRMApprovalTotal = parseInt(response.data.data.SuperAgent.West.RMApprove)
                + parseInt(response.data.data.SuperAgent.East.RMApprove) + parseInt(response.data.data.SuperAgent.North.RMApprove)
                + parseInt(response.data.data.SuperAgent.South1.RMApprove) + parseInt(response.data.data.SuperAgent.South2.RMApprove)
                + parseInt(response.data.data.SuperAgent.Central.RMApprove) + parseInt(response.data.data.SuperAgent.NorthEast.RMApprove);

                this.getSuperAgentDebitsData.Total.PendingHRApprovalTotal = parseInt(response.data.data.SuperAgent.West.HRApprove)
                + parseInt(response.data.data.SuperAgent.East.HRApprove) + parseInt(response.data.data.SuperAgent.North.HRApprove)
                + parseInt(response.data.data.SuperAgent.South1.HRApprove) + parseInt(response.data.data.SuperAgent.South2.HRApprove)
                + parseInt(response.data.data.SuperAgent.Central.HRApprove) + parseInt(response.data.data.SuperAgent.NorthEast.HRApprove);

                this.getSuperAgentDebitsData.Total.PendingFinanceApprovalTotal = parseInt(response.data.data.SuperAgent.West.FinanceApprove)
                + parseInt(response.data.data.SuperAgent.East.FinanceApprove) + parseInt(response.data.data.SuperAgent.North.FinanceApprove)
                + parseInt(response.data.data.SuperAgent.South1.FinanceApprove) + parseInt(response.data.data.SuperAgent.South2.FinanceApprove)
                + parseInt(response.data.data.SuperAgent.Central.FinanceApprove) + parseInt(response.data.data.SuperAgent.NorthEast.FinanceApprove);

              }
              else {
                this.getServiceCenterDebitsData = {},
                this.getLineHaulDebitsData = {},
                this.getVehicleVendorDebitsData = {},
                this.getSuperAgentDebitsData = {}
              }
              this.searchflag=true;
              this.searchDashboardCount = false
          })
          .catch((httpException) => {
              //this.$alertify.error("State data not found");
              this.searchDashboardCount = false
              console.error('exception is:::::::::', httpException)
          })

       }
       else {
         this.$alertify.error("To Date is greter than from Date");
       }
     },
     getShipmentAttachmentPopup(shippingID){
       this.attachmentLoader = true
       this.getAttachmentFlag= true
       let data={
         ShippingID: shippingID
       }
       axios.post(apiUrl.api_url + 'Lost/ShippindID/AttachmentDownload',data)
         .then((response) => {
             if(response.data.code == 200){
                this.getAttachmentListData = response.data.data;
             } else {
               this.getAttachmentListData = [];
             }
             this.attachmentLoader = false;
           })
         .catch((httpException) => {
              this.attachmentLoader = false;
             console.error('exception is:::::::::',httpException)
         });
     },
     closeAttachmentPopup(){
      this.getAttachmentFlag = false
     },
    getLostShipmetsDetails(HubZoneName,DebitFromType,SubStatus, isPagination = false){
      if(!isPagination) {
        this.pagecount = 0;
        this.pageno = 1
        this.$refs.paginate.selected= 0;
      }

      const el = this.$el.querySelector("#shipmentDetails");
       if (el) {
         el.scrollIntoView();
       }
      this.getLostShipmetsDetailsflag=false;
      this.searchShipmentSummary = true
      try {
        let payload = {};
        // if(HubZoneName == 'Total' || HubZoneName == ''){}
        // else {
        //   payload.HubZoneName = HubZoneName;
        //   this.HubZoneName = HubZoneName;
        // }
        payload.HubZoneName = HubZoneName;
        this.HubZoneName = HubZoneName;
        if(DebitFromType == 'Total' || DebitFromType == ''){}
        else {
          payload.DebitFromType = DebitFromType == 'SuperAgent' ? 'Courier': DebitFromType;
          this.DebitFromType = DebitFromType;
        }
        if(SubStatus == 'Total' || SubStatus == ''){}
        else {
          payload.Status = SubStatus;
          this.SubStatus = SubStatus;
        }

        payload.pageNo = this.pageno;
        payload.pageSize = 10;
        payload.ToDate = this.toDate;
        payload.FromDate = this.fromDate;

        if(DebitFromType =='Vendor' &&(SubStatus == 'Pending' || SubStatus == 'MarkLost' )){
          payload.isVendor = '1'
        }


        axios.post(apiUrl.api_url + 'ShipmentDetailsForDashboard/list', payload)
         .then((response) => {

             if(response.data.code == 200){
                  this.getLostShipmetsDetailsData = response.data.data;

                  let totalRows = response.data.totalCount;
                  if (totalRows < 10) {
                      this.pagecount = 1
                  } else {
                      this.pagecount = Math.ceil(totalRows / 10);
                  }
                  this.getLostShipmetsDetailsflag=true;
             }
             else {
               this.getLostShipmetsDetailsData = [];
               this.$alertify.error(response.data.message)
             }
             this.searchShipmentSummary = false
         })
         .catch((httpException) => {
            this.searchShipmentSummary = false
             console.error('exception is:::::::::', httpException)
         })
      } catch (e) {
        this.searchShipmentSummary = false
        console.log(e);
      }

    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //this.fromDate = this.fromDate;
          //this.toDate = this.toDate;
          this.getLostShipmetsData();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getPaginationData(pageNum) {
        this.pageno = pageNum;
        this.getLostShipmetsDetails(this.HubZoneName,this.DebitFromType,this.SubStatus, true);
    },
    clear(){
      this.fromDate = '';
      this.toDate = '';
      this.searchflag=false;
      this.getLostShipmetsDetailsflag=false;
      this.getServiceCenterDebitsData=[];
      this.getLineHaulDebitsData=[];
      this.getVehicleVendorDebitsData=[];
      this.getSuperAgentDebitsData=[];
      this.$validator.reset();
      this.errors.clear();
      this.pagecount = 1,
      this.pageno = 1
    },
  },
  filters: {
    calculateSum: function(obj) {
      let sumOfobj = Object.keys(obj).reduce((sum,key)=>sum+parseFloat(obj[key]||0),0);
      return sumOfobj;
    },
    calculateSumForLinehual: function(obj) {
      delete(obj.HRApprove);
      let sumOfobj = Object.keys(obj).reduce((sum,key)=>sum+parseFloat(obj[key]||0),0);
      return sumOfobj;
    },
    calculateSumForVendor: function(obj) {
      delete(obj.transitApproved);
      delete(obj.HRApprove);
      let sumOfobj = Object.keys(obj).reduce((sum,key)=>sum+parseFloat(obj[key]||0),0);
      return sumOfobj;
    },
    calculateSumForSuperAgent: function(obj) {
      delete(obj.transitApproved);
      delete(obj.Pending);
      delete(obj.MarkLost);
      let sumOfobj = Object.keys(obj).reduce((sum,key)=>sum+parseFloat(obj[key]||0),0);
      return sumOfobj;
    },
    changeDateFormat: function(date) {
      if (date != null || date != '') {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    },
    setDebitAmount: function(objValue) {
      let netPayment = objValue.NetPayment != null ? objValue.NetPayment : 0
      let OctroiMRP = objValue.OctroiMRP != null ? objValue.OctroiMRP : 0
      let debitamt =  parseFloat(netPayment) >= parseFloat(OctroiMRP) ? netPayment : OctroiMRP
      // console.log('netPayment ===>>', netPayment);
      // console.log('octarioMRP ===>>', OctroiMRP);
      // console.log('debitamt ===>>', debitamt);
      return debitamt
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/LostModuleDashboard/LostModuleDashboard.component.js